import { Box, Paper, PaperProps, Typography } from '@mui/material';
import { ReactNode } from 'react';

export interface GraphProps extends Omit<PaperProps, 'children'> {
  title?: string;
  children: ReactNode;
  height?: number | string;
  loading?: boolean;
}

export const Graph = ({
  title,
  children,
  height = 300,
  loading = false,
  sx,
  ...props
}: GraphProps) => {
  return (
    <Paper
      sx={{
        p: 2,
        ...sx,
      }}
      {...props}
    >
      {title && (
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
      )}
      <Box
        sx={{
          height,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        {loading ? (
          <Typography color="text.secondary">Loading...</Typography>
        ) : (
          children
        )}
      </Box>
    </Paper>
  );
};

export default Graph;
